/**
 * Per-surface how-to dismissal, mirrored into a cookie so the SERVER can
 * paint the card collapsed on the very first byte.
 *
 * WHY A COOKIE AND NOT JUST localStorage. The original strip kept its flag
 * in localStorage only, and `getServerSnapshot` had no way to read it — so
 * every full load of every surface painted the 182px card EXPANDED and then
 * collapsed it after hydration (polish-pass audit 2026-08-23 §1: ~150-180px
 * layout jump above the work, six surfaces, every load, even after "Faham").
 * A cookie rides the request, so the page reads it via `cookies()` (the same
 * mechanism as the persisted outlet, ./outlet-server.ts) and hands
 * `initiallyDismissed` to the client store, whose server snapshot is then
 * the REAL value. localStorage stays as the client fallback (private mode,
 * a cleared cookie jar), and a storage-only dismissal from before this cookie
 * existed is mirrored forward once on the client (see howto-store.tsx).
 *
 * Value is the literal `1`; anything else reads as "not dismissed". The
 * cookie is user-writable and gates nothing but a help card.
 */
export const SUPPLY_HOWTO_COOKIE_PREFIX = "fb_supply_howto_";
export const SUPPLY_HOWTO_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function howtoCookieName(surface: string): string {
  return `${SUPPLY_HOWTO_COOKIE_PREFIX}${surface}`;
}

/** The localStorage key — same name as the cookie, value `dismissed`. */
export function howtoStorageKey(surface: string): string {
  return howtoCookieName(surface);
}

export function howtoDismissedFromCookieValue(raw: string | undefined): boolean {
  return raw === "1";
}

/** Browser-side write. Path is explicit: the default would scope the
 * cookie to the current directory and fragment it per surface URL. */
export function writeHowtoDismissedCookie(surface: string): void {
  document.cookie = `${howtoCookieName(surface)}=1; path=/; max-age=${SUPPLY_HOWTO_COOKIE_MAX_AGE}; SameSite=Lax`;
}
